import { useGetRegisterCompositionQuery } from '@schooly/api';
import { useMemo, useRef, useState } from 'react';
import { UseFormReturn } from 'react-hook-form-lts';

import { RegisterGroupIds } from './types';
import { emptyGroupIds, seedGroupIdsFromComposition } from './utils/registerGroupIds';

export type RegisterCreateForm = {
  register_date: string;
  group_ids: RegisterGroupIds;
};

type UseRegisterCompositionParams = {
  form: UseFormReturn<RegisterCreateForm>;
  registerId?: string;
};

export const useRegisterComposition = ({ form, registerId }: UseRegisterCompositionParams) => {
  const isEdit = !!registerId;
  const seededRegisterIdRef = useRef<string>();
  const [isSeeded, setIsSeeded] = useState(false);

  const { data: composition, isError } = useGetRegisterCompositionQuery(registerId || '', {
    enabled: isEdit,
    refetchOnMount: 'always',
    onSuccess: (composition) => {
      if (seededRegisterIdRef.current === registerId) return;
      seededRegisterIdRef.current = registerId;

      form.reset({
        register_date: composition.register_date,
        group_ids: seedGroupIdsFromComposition(composition.groups),
      });
      setIsSeeded(true);
    },
  });

  const initialRosterIds = useMemo(
    () => (composition ? seedGroupIdsFromComposition(composition.groups) : emptyGroupIds()),
    [composition],
  );

  return {
    composition,
    initialRosterIds,
    isSeeded: !isEdit || isSeeded,
    compositionLoading: isEdit && !isSeeded && !isError,
  };
};
